import { AppBar } from '@mui/material';
import { styled } from '@mui/material/styles';

import { rem, Theme } from '../../theme';
import { ButtonBase } from '../Button';

interface StyledAppBarProperties {
    $hasSnackBar: boolean;
    $appBannerVisible: boolean;
    $showBorderBottom: boolean;
    $isExperimentVariant: boolean;
}

export const StyledAppBar = styled(AppBar, {
    shouldForwardProp: property =>
        typeof property === 'string' && !property.startsWith('$'),
})<StyledAppBarProperties>`
    ${({
        theme,
        $hasSnackBar,
        $appBannerVisible,
        $isExperimentVariant,
        $showBorderBottom,
    }) => `
        top: ${$appBannerVisible ? theme.tggSpacing(rem(5.5), 13.75) : theme.tggSpacing(0, 0)};
        height: ${$hasSnackBar ? theme.tggSpacing(rem(9.6), 24) : theme.tggSpacing(rem(6), 14)};
        background-color: ${
            $isExperimentVariant
                ? `${theme.palette.energyBlue[500]}`
                : `${theme.getRebrandingColor(
                      theme.palette.primary.main,
                      theme.palette.tgg.surface.brand,
                  )};`
        };
        padding: ${theme.tggSpacing('unset', [1, 4, 1, 6])};
        ${theme.breakpoints.up('desktop')} {
            height: ${$hasSnackBar ? theme.tggSpacing(rem(11.8), 29.5) : theme.tggSpacing(rem(7.2), 18)};
        padding: ${theme.tggSpacing('unset', [0, 10, 0, 12])};
        }
        ${theme.breakpoints.up('largeDesktop')} {
        padding: ${theme.tggSpacing('unset', [0, 20, 0, 20])};
        }
        border-bottom: ${
            $showBorderBottom && !$hasSnackBar
                ? `${theme.tggSpacing(rem(0.1), 0.25)} solid ${theme.palette.grey[200]}`
                : theme.tggSpacing(0, 0)
        };
        box-shadow: none;
	`}
`;

export const StyledLogoContainer = styled('div')`
    ${({ theme }: { theme: Theme }) => `
        margin-left: ${theme.tggSpacing(rem(1.3), 5)};
        ${theme.breakpoints.up(375)} {
            margin-left: ${theme.tggSpacing(rem(1.5), 3.75)};
        }
        ${theme.breakpoints.up('desktop')} {
            margin-left: ${theme.tggSpacing(rem(11.5), 28.75)};
        }
	`}
`;

export const StyledLinksContainer = styled('div')`
    ${({ theme }: { theme: Theme }) => `
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        height: 100%;
        ${theme.breakpoints.up('desktop')} {
            margin-right: ${theme.tggSpacing(rem(9.1), 22.75)};
        }
        .returnUserBasket {
            transform: translate(0, 0.05rem);
        }
	`}
`;

export const StyledButton = styled(ButtonBase)`
    ${({ theme }: { theme: Theme }) => `
        margin-right: ${theme.tggSpacing(rem(2), 5)};
	`}
`;

export const StyledContainer = styled('div')`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    height: 100%;
`;

export const StyledSnackBarContainer = styled('div')`
    ${({ theme }: { theme: Theme }) => `
        height: ${theme.tggSpacing(rem(4.6), 11.5)};
	`}
`;
